import { connect } from '@atlassian/jira-react-redux';
import {
	getRecentEstimatedData,
	getRecentCompletedData,
	getRecentSprintAxisLabels,
	getCurrentEstimationStatistic,
	getYAxisLabel,
} from '../../state/selectors/chart';
import { getTimeTrackingOptions } from '../../state/selectors/time-tracking-options';
import type { State } from '../../state/types';
import Chart, { type Props } from './view';

const mapStateToProps = (state: State): Props => ({
	estimatedData: getRecentEstimatedData(state),
	completedData: getRecentCompletedData(state),
	axisLabels: getRecentSprintAxisLabels(state),
	yAxisLabelMessage: getYAxisLabel(state),
	estimationStatistic: getCurrentEstimationStatistic(state),
	timeTrackingOptions: getTimeTrackingOptions(state),
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const mapDispatchToProps: Record<string, any> = {};

export default connect(mapStateToProps, mapDispatchToProps)(Chart);
